import firebaseErrorMessages from '../constants/firebase';

function humanize(errorCode) {
  return firebaseErrorMessages[errorCode];
}

export default function errorCodeToMessage(error) {
  if (typeof (error) === 'string') {
    return humanize(error);
  }
  let errorCode;
  if (error.code) {
    errorCode = error.code;
  } else {
    errorCode = error.body.Error;
  }
  console.log(errorCode);
  return humanize(errorCode);
}



// WEBPACK FOOTER //
// ./src/helpers/firebase.js